<template>
  <div>
    <Hero title="Impressum" />
    <section class="container content">
      <div class="breadcrumb d-flex">
        <div class="flex-grow-1">
          <nuxt-link :to="localePath('/')">Home</nuxt-link>
          <span class="breadcrumb--separator">></span>
          {{ $t('Impressum') }}
        </div>
      </div>

      <h2>{{ $t('Herausgeber') }}</h2>

      <impressumFr v-if="$i18n.locale == 'fr'" />

      <div v-else>
        <strong>LerNetz AG</strong>
        <br />
        Kornhausplatz 14
        <br />
        3011 Bern
        <br />
        <br />
        <a
          href="https://www.lernetz.ch"
          target="_blank"
        >
          www.lernetz.ch
        </a>
        <br />
        <br />

        Handelsregister Nr: CHE-109.405.591
        <br />
        <br />
        <br />

        <strong>orbit7 gmbh</strong>
        <br />
        Tellstrasse 8
        <br />
        3014 Bern
        <br />
        <br />
        <a
          href="https://www.orbit7.ch"
          target="_blank"
        >
          www.orbit7.ch
        </a>
        <br />
        <br />

        Handelsregister Nr: CHE-439.790.639
        <br />
        <br />
        <br />

        Bei weiteren Fragen nim mit uns
        <a href="mailto:info@lernpfad.ch">Kontakt</a>
        auf.
        <br />
        <br />
        <br />

        Die Betreiberin übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen
        Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und
        Vollständigkeit der Informationen. Haftungsansprüche gegen die
        Betreiberin wegen Schäden materieller oder immaterieller Art, welche aus
        dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten
        Informationen, durch Missbrauch der Verbindung oder durch technische
        Störungen entstanden sind, werden ausgeschlossen.
        <br />

        Alle Angebote sind unverbindlich. Die Betreiberin behält es sich
        ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne
        besondere Ankündigung zu verändern, zu ergänzen, zu löschen oder die
        Veröffentlichung zeitweise oder endgültig einzustellen.
        <br />

        <h2>Haftungsausschluss für externe Links und Dienste</h2>

        Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres
        Verantwortungsbereichs. Es wird jegliche Verantwortung für externe
        Dienste abgelehnt. Der Zugriff und die Nutzung solcher Dienste erfolgen
        auf eigenes Risiko der jeweiligen Nutzenden.
      </div>
    </section>
  </div>
</template>

<script>
import Hero from '../components/ui/Hero'
import impressumFr from '../components/locales/impressum_fr.vue'

export default {
  components: {
    Hero,
    impressumFr,
  },

  scrollToTop: true,

  head() {
    return {
      title: this.$i18n.t('Impressum | Lernpfad'),
    }
  },
}
</script>

<style
  scoped
  lang="scss"
>
@import '../assets/style/utils';

.content,
::v-deep .content {
  margin-top: 5em;

  h2 {
    margin: 2rem 0 1rem 0;
    @include fontSizeLineHeight(35px, 66px);
  }
}
</style>
